<template>
  <div id="edit-project">
    <form novalidate @submit.prevent="updateProject">
      <v-container grid-list-xl fluid>
        <v-layout row wrap>
             <v-dialog
        v-model="create_job_v"
        width="500"
      >
        <v-card>
          <v-card-title
            class="headline grey lighten-2"
            primary-title>
           {{'general._create_job_'|translate}}
          </v-card-title>
          <v-card-text>
           {{'general._create_job_'|translate}}
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
           <v-btn class="md-primary" @click="create_job_v = false">{{'general._close_'|translate}}</v-btn>
            <v-btn class="md-primary" @click="newJob">{{'general._create_job_'|translate}} </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
       
       
  
          <v-snackbar v-model="infoUpdatedSnack">
            <span>{{'general._project_saved_succ_'|translate}}</span>
            <v-btn class="md-primary" @click="infoUpdatedSnack = false">{{'general._ok_'|translate}}</v-btn>
          </v-snackbar>
          <!-- project form -->
          <v-toolbar :md-elevation="1">
            <span class="md-title">{{'project._project_name_'|translate}}: {{form.title}}</span>
            
            <span class="md-title">{{'project._created_Date_'|translate}} : {{ form.createdDate }}</span>
          </v-toolbar>
          <br>

          <v-flex sm6 style="display:none">
            <v-text-field
              label="Titre du project"
              type="text"
              autocomplete="given-name"
              v-model="project_id"
              required
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              :label="$t('project._project_name_')"
              v-model="form.title"
              autocomplete="given-name"
              required
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-widget :title="$t('project._expiration_date_')" class="mt-3">
              <div slot="widget-content">
                <v-dialog
                  ref="dialog"
                  persistent
                  v-model="modal"
                  lazy
                  full-width
                  width="290px"
                  :return-value.sync="date"
                >
                  <v-text-field
                    slot="activator"
                    :label="$t('project._expiration_date_')"
                    v-model="form.ending_date"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="form.ending_date" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="modal = false">{{'general._cancel_'|translate}}</v-btn>
                    <v-btn flat color="primary" @click="$refs.dialog.save(date)">{{'general._ok_'|translate}}</v-btn>
                  </v-date-picker>
                </v-dialog>
              </div>
            </v-widget>
          </v-flex>
          <v-flex xs12>
            <h5>{{'project._project_desc_'|translate}}</h5>

            <v-textarea
              placeholder="Détailler"
              ref="projectDescription"
              v-model="form.description"
              :min-height="30"
              :max-height="350"
              required
              outline
            ></v-textarea>
          </v-flex>

          <v-flex xs12 sm6>
            <v-text-field
            :label="$t('project._donation_accumulated_')"
             
              type="number"
              min="0"
              v-model.number="form.donation_accumulated"
              required
              suffix="dollar"
            ></v-text-field>
          </v-flex>

          
          <v-flex xs12 sm6>
            <v-text-field
             :label="$t('project._donation_objective_')"
              type="number"
              min="0"
              v-model.number="form.donation_objective"
              required
              suffix="dollar"
            ></v-text-field>
          </v-flex>

           <v-flex xs12 sm6>
            <v-text-field
             :label="$t('project._employees_accumulated_')"
              
              type="number"
              min="0"
              v-model.number="form.employees_accumulated"
              required
              suffix="dollar"
            ></v-text-field>
          </v-flex>

          
          <v-flex xs12 sm6>
            <v-text-field
            :label="$t('project._employees_objective_')"
             
              type="number"
              min="0"
              v-model.number="form.employees_objective"
              required
              suffix="dollar"
            ></v-text-field>
          </v-flex>


              <v-flex xs12 sm6>
            <v-text-field
            :label="$t('project._hours_accumulated_')"
            
              type="number"
              min="0"
              v-model.number="form.hours_accumulated"
              required
              suffix="heures"
            ></v-text-field>
          </v-flex>

          
          <v-flex xs12 sm6>
            <v-text-field
              :label="$t('project._hours_objective_')"
              
              type="number"
              min="0"
              v-model.number="form.hours_objective"
              required
              suffix="heures"
            ></v-text-field>
          </v-flex>


          <v-flex xs12 sm6>
            <v-select
              :items="projectStati"
              v-model="form.status"
              :label="$t('project._status_project_')"
              item-text="statut"
              item-value="abbr"
              single-line
            ></v-select>
          </v-flex>

          <v-flex xs12 sm6>
            <v-select
              :items="projectTypes"
              v-model="form.type"
               :label="$t('project._type_project_')"
            
              item-text="type"
              item-value="abbr"
              single-line
            ></v-select>
          </v-flex>
  
          <v-flex xs12 sm6>
           
              <v-select
              :items="areas"
              v-model="form.city"
               name="city"
              id="city"
              :label="$t('coupons._cop_city_')"
              single-line
               required
            ></v-select>
            
          </v-flex>

          <v-flex xs12 sm6>
            <v-text-field
             :label="$t('coupons._cop_civic_')"
              type="text"
              autocomplete="address"
              v-model="form.address"
              required
            ></v-text-field>
          </v-flex>

                    <v-flex xs12 sm6>
            <v-text-field
             :label="$t('coupons._cop_postalCode_')"
              type="text"
              autocomplete="postalCode"
              v-model="form.postalCode"
              required
            ></v-text-field>
          </v-flex>
        <v-flex xs12 sm6>
        <span>{{'jobs._emps_'|translate}} :</span>
          <multiselect
                v-model="form.employees"
                :options="employees"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="false"
                :hide-selected="true"
                :preserve-search="true"
                label="display_name"
                track-by="id"
                :preselect-first="false"
                ref="selecteemplyeesSelect"
              ></multiselect>
          <!--   {{form.employees}} -->
          </v-flex>

    <v-flex xs12 class="text-xs-center text-sm-center text-md-center text-lg-center">
          <div v-for="(image,image_key) in imageUrl" v-bind:key="image_key" >
        	<img :src="image" height="150" v-if="image"/>
          </div>
					<v-text-field label="Select Image" @click='pickFile' v-model='imageName' prepend-icon='attach_file'></v-text-field>
					<input
						type="file"
						style="display: none"
						ref="image"
						accept="image/*"
						@change="onFilePicked"
            multiple="multiple"
					>

				</v-flex>

          <v-flex xs12>
            <v-layout row wrap>
              <v-card-actions style="display:inline">
                <v-btn @click="deleteProject" color="primary">{{'general._delete_'|translate}}</v-btn>
              </v-card-actions>

              <v-card-actions style="display:inline">
                <router-link :to="{ name: 'widget-projects'}">
                  <v-btn color="primary">{{'general._back_'|translate}}</v-btn>
                </router-link>
              </v-card-actions>

              <v-spacer></v-spacer>

              <v-card-actions style="display:inline">
              <router-link :to="{ name: 'widget-post'}">
                  <v-btn color="primary">{{'project._create_job_'|translate}}</v-btn>
                </router-link>
              </v-card-actions>
              <v-card-actions style="display:inline">
                <v-btn type="submit" color="primary">{{'general._save_'|translate}}</v-btn>
              </v-card-actions>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </form>
  </div>
</template>

<script>
/* eslint-disable */
import { db } from "@/api/firebaseInit";
import firebase from "firebase";
import { storage } from '@/api/firebaseInit';
import vueSlider from "vue-slider-component";
import { quartiers } from "@/api/quartiers";
import { communes } from "@/api/communes";
import Image  from "@/Models/Image";

const toLower = text => {
  return text.toString().toLowerCase();
};

const searchByName = (items, term) => {
  if (term) {
    return items.filter(item => toLower(item.title).includes(toLower(term)));
  }

  return items;
};
export default {
  name: "edit-project",
  components: {
    vueSlider
  },
    computed: {
    employees () {
      let employees = this.$store.getters.employees;
      
       let employees_list = [];
      for(var i=0;i<employees.length;i++) {
        employees_list.push({display_name :employees[i].fullName,id:employees[i].id})

      }
      
      return employees_list;
    }
  }, 
  watch: {
    employees () {
      let employees = this.$store.getters.employees;    
       let employees_list = []
      for(var i=0;i<employees.length;i++) {
         employees_list.push({fullName:employees[i].fullName,id:employees[i].id})

      }
      
      return employees_list;
    }
  }, 
  mounted() {  
    this.fetchImages();
    
  },
  created() {
    this.project_id = this.$route.params.project_id;
    this.created_by_id = firebase.auth().currentUser.uid;
    this.created_by = firebase.auth().currentUser.displayName;
    this.fetchImages();
  },
  filters: {
    formatDate: function(value) {
      if (value) {
        return moment(String(value)).format("MM/DD/YYYY");
      }
    }
  },
  data() {
    return {
      selected: null,
      options: ['list', 'of', 'options'],
      old_images:[],
      images: [],
      images_2: [],
      imageName: [],
      imageUrl: [],
      imageFile: "",
      members: [],
      loading: true,
      pagination: {
        sortBy: "title",
        rowsPerPage: "100"
      },
      headers: [
        {
          text: "Nom du Projet",
          align: "left",
          value: "title"
        },
        { text: "Déscription", value: "description" },
        { text: "Salaire", value: "hourly_wage" }
      ],
      projectStati: ["Nouveau", "En cours", "Terminé"],
      projectTypes: [
        "Construction",
        "Administrative",
        "Education",
        "Levé de fonds"
      ],
      date: null,
      menu: false,
      modal: false,
      dOptions: {
        value: [0, 500],
        min: 0,
        max: 500,
        show: false,
        tooltip: "always",
        formatter: "{value}",
        tooltipDir: ["top", "top"],
        height: 8,
        show: true,
        dotSize: 20,
        overlapFormatter: "¥{value1} ~ ¥{value2}",
        bgStyle: {
          backgroundColor: "#8039CB"
        },
        processStyle: {
          backgroundColor: "#fff",
          boxShadow: "inset 0.5px 0.5px 3px 1px rgba(0,0,0,.36)"
        },
        tooltipStyle: {
          backgroundColor: "#8039CB",
          borderColor: "#666"
        }
      },
      infoUpdatedSnack: false,
      selected: {},
      search: null,
      searched: [],
      jobs: [],
      backers: [],
      project_id: null,
      zones: quartiers,
      areas: communes,
      showBackers: false,
      showJobs: false,
      create_job_v:false,
      job_id: null,
      
      form: {
                address:'',
                city:'',
                created_by_id:'',
                created_date:new Date(),
                description: "",
                donation_accumulated:0,
                donation_objective:0,
                employees :[],
                employees_accumulated:0,
                employees_objective:0,
                ending_date:new Date(),
                hours_accumulated:0,
                hours_objective:0,
                id:this.project_id,
                images:[],
                postalCode:"",
                title: "",
                status: "",
                type:"",
                update_date:new Date(),
                updated_by:this.created_by,
                updated_by_id:this.created_by_id
       /*  createdDate: Date,
        title: null,
        description: null,
        endingDate: null,
        pointOfInterest: "",
        volunteering_hours_objective: 100,
        volunteering_hours_current_amount: 0,
        donation_objective: 100,
        donationAccumulated: 0,
        employees_employed: 0,
        employees_number_objective: 100,
        backers: null,
        created_by_id: null,
        email: "",
        type: "",
        status: "",
        address: null,
        city: null,
        postalCode: null,
        updatedBy: firebase.auth().currentUser.displayName,
        updatedDate: null */
      }
    };
  },
  beforeRouteEnter(to, from, next) {
    db.collection("projects")
      .doc(to.params.project_id)
      .get()
      .then(function(doc) {
        next(vm => {

                  (vm.form.address=doc.data().address),
                  (vm.form.city=doc.data().city),
                  (vm.form.created_by_id=doc.data().created_by_id),
                  (vm.form.created_date=doc.data().created_date),
                  (vm.form.description= doc.data().description),
                  (vm.form.donation_accumulated=doc.data().donation_accumulated),
                  (vm.form.donation_objective=doc.data().donation_objective),
                  (vm.form.employees =doc.data().employees),
                  (vm.form.employees_accumulated=doc.data().employees_accumulated),
                  (vm.form.employees_objective=doc.data().employees_objective),
                  (vm.form.ending_date= new Date(doc.data().ending_date).toISOString().substr(0, 10)),
                  (vm.form.hours_accumulated=doc.data().hours_accumulated),
                  (vm.form.hours_objective=doc.data().hours_objective),
                  (vm.form.images=doc.data().images),
                  (vm.form.postalCode=doc.data().postalCode),
                  (vm.form.title=doc.data().title),
                  (vm.form.status=doc.data().status),
                  (vm.form.type=doc.data().type),
                  (vm.form.update_date=doc.data().update_date),
                  (vm.form.updated_by=doc.data().updated_by),
                  (vm.form.updated_by_id=doc.data().updated_by_id);

        /*   (vm.form.createdDate = doc.data().createdDate),
            (vm.form.title = doc.data().title),
            (vm.form.description = doc.data().description),
            (vm.form.volunteering_hours_objective = doc.data().volunteering_hours_objective),
            (vm.form.volunteering_hours_current_amount = doc.data().volunteering_hours_current_amount),
            (vm.form.donation_objective = doc.data().donation_objective),
            (vm.form.donationAccumulated = doc.data().donationAccumulated),
            (vm.form.employees_employed = doc.data().employees_employed),
            (vm.form.employees_number_objective = doc.data().employees_number_objective),
            (vm.form.endingDate = doc.data().endingDate),
            (vm.form.status = doc.data().status),
            (vm.form.backers = doc.data().backers),
            (vm.form.created_by_id = doc.data().created_by_id),
            (vm.form.address = doc.data().address),
            (vm.form.city = doc.data().city),
            (vm.form.postalCode = doc.data().postalCode),
            (vm.form.updatedBy = doc.data().updatedBy),
            (vm.form.type = doc.data().type),
            (vm.form.updatedDate = doc.data().updatedDate); */
        });
      });
  },
  watch: {
    $route: "fetchData"
  },
  methods: {
      newJob(){
      const that = this;
      const memberRef = db.collection("Jobs").doc();
      const refKey = memberRef.id;
      this.job_id = refKey;
      memberRef
        .set({
                updatedBy:this.created_by_id,
                id: this.job_id,
                address: {},
                available_position:0,
                created_by_id:this.created_by_id, 
                created_date:new Date(), 
                description:'', 
                hourly_wages:0,
                //job_end_date:'', 
                project_id:this.project_id,
               // project_name:'', 
                skills_required:'',
                start_date:new Date(), 
                title:'', 
                type:'',
                weekly_hours:0 

        })
        .then(() => {
          this.$store.dispatch('fetchJobs')
           this.$router.push({
            name: "components/modifiers-editjob",
            params: {
              job_id: that.job_id
            }
          });
        })
        .catch(error => {
          console.error("Error adding member: ", error);
        });
    }
      ,
    searchOnTable() {
      this.searched = searchByName(this.jobs, this.search);
    },
    getClass: ({ type }) => ({
      // 'md-primary':
    }),
    onSelect(item) {
      this.selected = item;
      this.$router.push({
        name: "edit-job",
        params: {
          job_id: item.job_id
        }
      });
    },
    fetchJobList() {
      db.collection("projects")
        .doc(this.project_id)
        .get()
        .then(doc => {
          this.jobs = doc.data().jobs;
        });
    },
    fetchImages() {
      db.collection("projects")
        .doc(this.project_id)
        .get()
        .then(doc => {
          if(doc.data().images)
         { this.old_images = doc.data().images;
        // console.log("naz 11"+this.old_images.length)
         }else { 
           this.old_images= [];
        //   console.log("naz"+this.old_images.length) 
        }
        });
    },
    fetchBackers() {
      db.collection("Users")
        .doc("Donations")
        .where("projectId", "==", this.project_id)
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            const data = {
              job_id: doc.id,
              title: doc.data().title,
              description: doc.data().description,
              projectName: doc.data().projectName
            };
            this.jobs.push(data);
            this.searched = this.jobs;
            this.showJobs = true;
          });
        });
    },

    fetchData() {
      db.collection("projects")
        .doc(this.project_id)
        .get()
        .then(function(doc) {

                  (this.form.address=doc.data().address),
                  (this.form.city=doc.data().city),
                  (this.form.created_by_id=doc.data().created_by_id),
                  (this.form.created_date=doc.data().created_date),
                  (this.form.description= doc.data().description),
                  (this.form.donation_accumulated=doc.data().donation_accumulated),
                  (this.form.donation_objective=doc.data().donation_objective),
                  (this.form.employees =doc.data().employees),
                  (this.form.employees_accumulated=doc.data().employees_accumulated),
                  (this.form.employees_objective=doc.data().employees_objective),
                  (this.form.ending_date=doc.data().ending_date),
                  (this.form.hours_accumulated=doc.data().hours_accumulated),
                  (this.form.hours_objective=doc.data().hours_objective),
                  (this.form.images=doc.data().images),
                  (this.form.postalCode=doc.data().postalCode),
                  (this.form.title=doc.data().title),
                  (this.form.status=doc.data().status),
                  (this.form.type=doc.data().type),
                  (this.form.update_date=doc.data().update_date),
                  (this.form.updated_by=doc.data().updated_by),
                  (this.form.updated_by_id=doc.data().updated_by_id);

      
            
        });
    },



    pickFile () {
            this.$refs.image.click ()
        },
		
		onFilePicked (e) {
      
      var that = this
    
      var files = e.target.files
      var blob="";
      var name ="";
      var images_s= [];
       that.images=[];
  for (var i = 0; i < e.target.files.length; i++) {
      
      var imageFile = e.target.files[i];
      
        if(imageFile !== undefined) {
        this.imageName.push(imageFile.name)
        for(var j=0;j< this.imageName.length;j++){
				if(this.imageName[j].lastIndexOf('.') <= 0) {
					return
        }
        } 
		 		const fr = new FileReader ()
				fr.readAsDataURL(imageFile)
				fr.addEventListener('load', () => {
					this.imageUrl.push(fr.result)
          this.imageFile = imageFile // this is an image file that can be sent to server...
          
        }) 
          blob = new Blob([imageFile], { type: e.target.files[i].type });
          console.log("blob",blob)
          name = this.project_id+"_"+"_"+new Date().getTime()
          const pictRef = storage
        .ref()
        .child(
          `projects/${this.project_id}/project-${new Date().getTime()}`
        );
      pictRef.put(blob).then(function(snapshot) {
        pictRef
          .getDownloadURL()
          .then(url => {
          that.saveImageUrl(url,name)
             url=''
             blob=''
             name='' 
        })
        
          .catch(function(error) {
            alert(`error--${error}`);
          });
      });
       
			} else {
				this.imageName = ''
				this.imageFile = ''
				this.imageUrl = ''
			}
    }
		},


    /*********************** */
       saveImageUrl (url,name) {
         var image = {name:name,url:url}
         this.images.push(image)
        // console.log("tab"+JSON.stringify(this.images))
        },
        

    /********************** */
    updateProject() {
      var that = this;
     // this.old_images=[];
        //that.fetchImages();
        var big_array=[];
        console.log("fix len"+that.old_images.length)
       if(that.old_images.length>0) {
         var old_imagess = that.old_images;
          big_array = that.images.concat(old_imagess); 
         console.log("big_array"+big_array.length)
      } else {
           big_array = that.images;   
      }
      this.form.updatedDate = new Date();
      db.collection("projects")
        .doc(this.project_id)
        .update({

                address:this.form.address,
                city:this.form.city,
                created_by_id:this.created_by_id,
                created_date:new Date(),
                description: this.form.description,
                donation_accumulated:this.form.donation_accumulated,
                donation_objective:this.form.donation_objective,
                employees :this.form.employees,
                employees_accumulated:this.form.employees_accumulated,
                employees_objective:this.form.employees_objective,
                ending_date:this.form.ending_date,
                hours_accumulated:this.form.hours_accumulated,
                hours_objective:this.form.hours_objective,
                images:big_array,
                postalCode:this.form.postalCode,
                title: this.form.title,
                status: this.form.status,
                type:this.form.type,
                update_date:new Date(),
                updated_by:this.created_by,
                updated_by_id:this.created_by_id
        })
        .then(() => {
          that.images=[];
         // that.old_images=[];
          that.infoUpdatedSnack = true;
          this.create_job_v= true;
          this.$store.dispatch('fetchProjects')

        })
        .catch(error => {
          console.error("Error adding member: ", error);
        });
      
    },
/*     createJob() {
      var memberRef = db.collection("projects").doc(this.project_id);
      var refKey = memberRef.id;
      this.job_id = refKey;
      memberRef
        .set({
          created_by_id: this.created_by_id,
          updatedBy: this.created_by_id,
          projectId: this.project_id,
          projectName: this.form.title,
          createdDate: new Date(),
          address: this.form.address,
          city: this.form.city,
          postalCode: this.form.postalCode
        })
        .then(() => {
          this.$router.push({
            name: "new-job",
            params: {
              project_id: this.project_id,
              created_by_id: this.created_by_id,
              job_id: this.job_id,
              createdDate: new Date()
            }
          });
        })
        .catch(error => {
          console.error("Error adding member: ", error);
        });
      
    }, */
    deleteProject() {
      var that = this;
      if (confirm("Are you sure?")) {
        db.collection("projects")
          .doc(this.project_id)
          .delete()
          .then(function() {
            alert(`Ce projet a été suprimé`);
            this.$store.dispatch('fetchProjects');
            that.$router.push({name:'widget-projects'});

          });
      }
    },
    updateVolunteerSlider() {
      // $ref.vSlider.max = this.form.volunteeringHours
    }
  }
};
</script>
<style lang='scss' scoped>
.md-dialog {
  max-width: 768px;
}
body {
  padding-top: 70px;
}
.md-drawer {
  padding-top: 70px;
}

#my-strictly-unique-vue-upload-multiple-image {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/pages/modifiers/EditProject.vue